import React from "react";
import { useTranslation } from "react-i18next";
import { RoomParticipant } from "../../../api/room";
import styles from "./RoomHeader.module.scss";
import TitleIcon from "../../../components/icons/room/TitleIcon";
import FilterHeaderHash from "../../../components/icons/forYou/FilterHeaderHash";
import useInterfaceContext from "../../../components/providers/interface";
import InviteIcon from "../../../components/icons/room/Inviteicon";
import CloseIcon from "../../../components/icons/room/CloseIcon";

interface RoomHeaderProps {
  activeGenreNames: string[];
  filterCount: number;
  participants: RoomParticipant[];
  matchCount: number;
  onFilterClick: () => void;
  onMatchesClick: () => void;
  onInviteClick: () => void;
  isCreator: boolean;
  onEndSession: () => void;
}

const RoomHeader: React.FC<RoomHeaderProps> = ({
                                                 activeGenreNames,
                                                 filterCount,
                                                 participants,
                                                 onFilterClick,
                                                 onInviteClick,
                                                 isCreator,
                                                 onEndSession,
                                               }) => {
  const { t } = useTranslation();
  const { isMobile } = useInterfaceContext();

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left_column}>

          {isMobile && (
            <div className={styles.titleGroup}>
            <span className={styles.titleIcon} onClick={onFilterClick}>
              <TitleIcon/>
              {filterCount > 0 && (
                <span className={styles.filterBadge}>{filterCount}</span>
              )}
              </span>
              <span className={styles.title}>{t("room_public_room", "Share Pick")}</span>
            </div>
          )}

          {activeGenreNames.length > 0 && !isMobile && (
            <div className={styles.filterTags}>
              <FilterHeaderHash
                className={`${styles.iconClass} ${styles.iconExtraClass}`}
                fill="#00AAAA"
                width={9}
                height={10}
              />
              {activeGenreNames.slice(0, 3).map((name) => (
                <span key={name} className={styles.tag}>{t(name)}</span>
              ))}
            </div>
          )}

          {isMobile && (
            <div className={styles.left_column_holder}>
              {participants.length > 0 && (
                <div className={styles.avatars}>
                  {participants.slice(0, 3).map((p, idx) => (
                    <div
                      key={p.user_id}
                      className={styles.avatar}
                      style={{ zIndex: idx + 1 }}
                      title={p.username}
                    >
                      {p.picture_url && (
                        <img
                          src={p.picture_url}
                          alt=""
                          onLoad={(e) => {
                            const target = e.currentTarget;
                            target.style.display = "block";
                            if (target.nextElementSibling) {
                              (target.nextElementSibling as HTMLElement).style.display = "none";
                            }
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      )}
                      <span>{(p.username || "U").charAt(0).toUpperCase()}</span>
                    </div>
                  ))}
                  {participants.length > 3 && (
                    <div className={styles.avatarMore} style={{ zIndex: 4 }}>
                      <span>+{participants.length - 3}</span>
                    </div>
                  )}
                </div>
              )}

              <button className={styles.inviteBtn} onClick={onInviteClick}>
                <InviteIcon/>
              </button>
            </div>
          )}
        </div>

        {!isMobile && (
          <>
            <div className={styles.center_column}>
              <button className={styles.inviteBtn} onClick={onInviteClick}>
                <InviteIcon/>
                {t("room_invite", "Invite")}
              </button>

              {participants.length > 0 && (
                <div className={styles.avatars}>
                  {participants.slice(0, 3).map((p, idx) => (
                    <div
                      key={p.user_id}
                      className={styles.avatar}
                      style={{ zIndex: idx + 1 }}
                      title={p.username}
                    >
                      {p.picture_url && (
                        <img
                          src={p.picture_url}
                          alt=""
                          onLoad={(e) => {
                            const target = e.currentTarget;
                            target.style.display = "block";
                            if (target.nextElementSibling) {
                              (target.nextElementSibling as HTMLElement).style.display = "none";
                            }
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      )}
                      <span>{(p.username || "U").charAt(0).toUpperCase()}</span>
                    </div>
                  ))}
                  {participants.length > 3 && (
                    <div className={styles.avatarMore} style={{ zIndex: 4 }}>
                      <span>+{participants.length - 3}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className={styles.right_column}>
              {isCreator && (
                <button className={styles.closeRoomBtn} onClick={onEndSession}>
                  <CloseIcon/>
                  <span>{t("room_end_session", "Close Room")}</span>
                </button>
              )}
            </div>
          </>

        )}

        {activeGenreNames.length > 0 && isMobile && (
          <div className={styles.filterTags}>
            <FilterHeaderHash
              className={`${styles.iconClass} ${styles.iconExtraClass}`}
              fill="#00AAAA"
              width={9}
              height={10}
            />
            {activeGenreNames.slice(0, 3).map((name) => (
              <span key={name} className={styles.tag}>{t(name)}</span>
            ))}
          </div>
        )}



      </div>
    </>

  );
};

export default RoomHeader;
